/**
 * Unit (Unidade / posto de trabalho) types
 */

export enum UnitStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const UNIT_STATUS_LABELS: Record<UnitStatus, string> = {
  [UnitStatus.ACTIVE]: 'Ativa',
  [UnitStatus.INACTIVE]: 'Inativa',
};

export interface Unit {
  id: number;
  companyId: number;
  name: string;
  location?: string | null;
  status: UnitStatus;
  isObra: boolean;
  createdAt?: string;
  updatedAt?: string;
}

/** A unidade como vem na lista: com quantos setores estão ligados a ela (#541). */
export interface UnitNaLista extends Unit {
  setoresLigados: number;
  hasFronts: boolean;
}

/**
 * Quem uma aplicação à unidade alcança (`GET /units/:id/alcance`, #541). O funcionário é
 * alcançado pelo setor, então quem tem a unidade no cadastro mas está em setor de outra unidade
 * conta em `funcionariosForaDoAlcance`, e não em `funcionarios`.
 */
export interface AlcanceDaUnidade {
  setores: number;
  cargos: number;
  funcionarios: number;
  funcionariosForaDoAlcance: number;
  aplicacoes?: {
    riscos?: number;
    exames?: number;
    fontes?: number;
  };
}

export interface CreateUnitRequest {
  name: string;
  companyId: number;
  location?: string;
  status?: UnitStatus;
  isObra?: boolean;
}

export type UpdateUnitRequest = Partial<CreateUnitRequest>;

export interface UnitFilters {
  search?: string;
  companyId?: number;
  status?: UnitStatus;
}
